<template>
    <div id="view">
        <index/>
        <view1/>
        <view2/>
        <view3/>
        <view4/>
        <view5/>
        <view6/>
        <view7/>
        <view8/>
    </div>
</template>
<script> 
import index from '@/page/index/index.vue'

export default {
    name: 'IndexView',
    components: {
        // 首屏关键组件保持同步加载以保证 FCP/LCP
        index,
        // 非首屏视图异步加载，实现代码分割
        view1: () => import('./view1.vue'),
        view2: () => import('./view2.vue'),
        view3: () => import('./view3.vue'),
        view4: () => import('./view4.vue'),
        view5: () => import('./view5.vue'),
        view6: () => import('./view6.vue'),
        view7: () => import('./view7.vue'),
        view8: () => import('./view8.vue'),
    }
}
</script>